import { Component, NgZone } from '@angular/core';
import { App } from '@capacitor/app';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { PlatformchkService } from './services/platformchk.service';
import OneSignal from 'onesignal-cordova-plugin';
import { environment } from 'src/environments/environment';
import  channelService  from './services/channel.service';
import  BranchService  from './services/branch.service';
import { MembershipService } from './services/membership.service';
import { LoadingService } from './services/load.service';
import { AlertService } from 'src/app/services/alert.service';
import 'cordova-plugin-purchase';
import { BranchDeepLinks, BranchInitEvent } from 'capacitor-branch-deep-links';
import { SplashScreen} from '@capacitor/splash-screen';
import { RouterUrlService } from './services/router-url.service';
import { StatusBar } from '@capacitor/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { Device } from '@capacitor/device';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  store?: CdvPurchase.Store;
  userId: string = localStorage.getItem('userId');
  deepLink;
  notification;

  constructor(
    public platformchk: PlatformchkService,
    public platform: Platform,
    private membership: MembershipService,
    private load: LoadingService,
    private alert: AlertService,
    private routerURL: RouterUrlService,
    private navc: NavController,
    private ngZone: NgZone,
    public modalController: ModalController,
    private translate: TranslateService,
  ) {
    this.initializeApp();
    this.routerURL.initRouter();
  }

  ngOnInit() {
    App.addListener('appStateChange', ({ isActive }) => {
      this.ngZone.run(() => {
        if (isActive) {
          // 앱이 포그라운드로 올라왔을 때
          this.handleDeepLink();
          this.handleNotification();
        } else {
          // 앱이 백그라운드로 전환되었을 때
          // console.log('App is now in the background!');
        }
      });
    });
  }

  // 다국어 설정
  async setLanguage() {
    const lang = localStorage.getItem('lang');
    if(['ko', 'en', 'ja'].includes(lang)) {
      this.translate.use(lang);
    }else {
      let language = 'ko';
      if (this.platformchk.isApp) {
        const languageCode = await Device.getLanguageCode();
        language = languageCode.value;
        language = language.split('-')[0];
      }else {
        language = window.navigator.language;
        language = language.split('-')[0];
      }

      this.translate.use(language);
    }
  }

  async initializeApp() {
    this.platform.ready().then(async () => {
// localStorage.setItem('userId', 'naver:JegoH92ZYX0rODB');
      
      await this.setLanguage();

      if (this.platformchk.isApp) {
        StatusBar.setOverlaysWebView({ overlay: false });

        this.storeSetting();

        OneSignal.Debug.setLogLevel(6);
        OneSignal.initialize(environment.onesignalID);

        OneSignal.Notifications.canRequestPermission().then(() => {
          OneSignal.Notifications.requestPermission(false).then((accepted: boolean) => {
            console.log("User accepted Notification: " + accepted);
          });
        });

        OneSignal.Notifications.addEventListener('click', (event) => {
          console.log('Notification clicked!', event);
          this.notification = event.notification.additionalData;
        });
        OneSignal.Notifications.clearAll();
        

        BranchDeepLinks.addListener('init', (event: BranchInitEvent) => {
          // Retrieve deeplink keys from 'referringParams' and evaluate the values to determine where to route the user
          // Check '+clicked_branch_link' before deciding whether to use your Branch routing logic
          console.log('branchEvent: ', JSON.stringify(event.referringParams));
          this.deepLink = event.referringParams;
        });

        BranchDeepLinks.addListener('initError', (error: any) => {
          console.error('branchInitError:', JSON.stringify(error));
        });
        
      }else {
        BranchService.loadScript().then(() => {
          BranchService.init();
        });
      }

      channelService.loadScript();
      channelService.boot({
        "pluginKey": "181852e5-b202-4fc0-a5b6-faedd8cf6a31",
      });

      setTimeout(() => {
        SplashScreen.hide({ fadeOutDuration: 500 }).then(() => {
          this.handleDeepLink();
          this.handleNotification();
        });
      }, 3000);

      this.platform.backButton.subscribeWithPriority(10, async () => {
        const topModal = await this.modalController.getTop();
        if (topModal) {
          await this.closeAllModals();
        } else {
          await this.navc.pop();
        }
      });
      window.addEventListener('popstate', async (event) => {
        if(this.platformchk.isAndroid) {
          await this.closeAllModals();
        }
      });
    });
  }

  /**
   * 현재 열린 모든 모달 닫기
   * @returns true: 모달 닫음, false: 모달 없음
   */
  private async closeAllModals(): Promise<boolean> {
    let closedAny = false;
    let topModal = await this.modalController.getTop();
    while (topModal) {
      await topModal.dismiss();
      closedAny = true;
      topModal = await this.modalController.getTop();
    }
    return closedAny;
  }

  storeSetting(): void {
    this.store = CdvPurchase.store;
    this.store.register([
      {
        id: 'neverland.heart40',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: 'neverland.heart40',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
      {
        id: 'neverland.heart200',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: 'neverland.heart200',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
      {
        id: 'neverland.heart500',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: 'neverland.heart500',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
      {
        id: 'neverland.heart700',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: 'neverland.heart700',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
      {
        id: 'neverland.heart900',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: 'neverland.heart900',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
      {
        id: 'neverland.heart4100',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
      },
      {
        id: 'neverland.heart4100',
        type: CdvPurchase.ProductType.CONSUMABLE,
        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
    ]);
    
    this.store.error((error) => {
      console.log('Purchase error::', error);
      this.membership.setState = false;
      this.membership.setPurchaseState = false;
      this.store.initialize();
    });

    this.store.when()
      .productUpdated(() => {
        console.log('Products loaded from the store:', this.store.products);
      })
      .approved(transaction => {
        console.log('Purchase approved::', transaction);
        transaction.verify();
      })
      .verified(receipt => {
        console.log('Purchase verified::', receipt);
        receipt.finish();
      })
      .finished(async transaction => {
        console.log('Purchase finished::', transaction);
        if (this.membership.getState) {
          await this.membership
            .paymentSuccess(transaction.products)
            .then(() => {
              this.load.hide();
            })
            .catch(() => {
              this.membership.setPurchaseState = false;
              this.alert.presentAlert(`${this.translate.instant('common.word.payFail')}`, `${this.translate.instant('common.word.storePayFail')}`);
            });
          }
        this.membership.setState = false;
        this.membership.setPurchaseState = false;
        this.store.initialize();
      });

    // Initialize the store
    this.store.initialize([
      {
        platform: CdvPurchase.Platform.APPLE_APPSTORE,
        options: {
          needAppReceipt: true,
        }
      },
      {
        platform: CdvPurchase.Platform.GOOGLE_PLAY,
      },
    ]);

    this.platform.resume.subscribe(() => {
      this.store.initialize(); // 영수증/거래 상태 갱신
    });
  }

  // branch DeepLink 이동
  handleDeepLink() {
    this.ngZone.run(() => {
      if(this.deepLink) {
        const params = JSON.parse(JSON.stringify(this.deepLink));
        this.deepLink = null;
        if(params['+clicked_branch_link'] === true) {
          if(params['$deeplink_path']) {
            // const visitor = this.userId ? '' : 'visitor-';
            // this.navc.navigateForward(`${visitor}${params['$deeplink_path']}`, {
            this.navc.navigateForward(`${params['$deeplink_path']}`, {
              queryParams: params['queryString'],
            });
          }
        }
      }
    });
  }

  // notification 페이지 이동
  handleNotification() {
    this.ngZone.run(() => {
      if(this.notification) {
        const params = JSON.parse(JSON.stringify(this.notification));
        this.notification = null;
        switch (params.type) {
          case 'notice':
            this.navc.navigateForward(['/notice'], {});
            break;
        }
      }
    });
  }
}
